export default "__VITE_ASSET__c6a1aa9d__"